import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { history } from "./CustomRouter"

const scrollToHash = (hash: string, attemptsLeft: number) => {
  const id = hash.replace("#", "")
  const el = document.getElementById(id)
  if (el) {
    console.log(
      "[ScrollRestoration] Element found for hash '#" +
        id +
        "', scrolling into view"
    )
    el.scrollIntoView({ behavior: "smooth" })
  } else if (attemptsLeft > 0) {
    console.log(
      "[ScrollRestoration] Element '#" +
        id +
        "' not yet in DOM, retrying... (" +
        attemptsLeft +
        " attempts left)"
    )
    setTimeout(() => scrollToHash(hash, attemptsLeft - 1), 150)
  } else {
    console.warn(
      "[ScrollRestoration] Element '#" +
        id +
        "' not found after all retries. The element may not exist on this page."
    )
  }
}

const ScrollRestoration = () => {
  const location = useLocation()

  useEffect(() => {
    sessionStorage.setItem("key", location.key)
  }, [location])

  // Handle hash scrolling on initial load and on in-app hash navigation
  useEffect(() => {
    if (!location.hash) return
    console.log(
      "[ScrollRestoration] Hash detected on location change:",
      location.hash,
      "| location.key:",
      location.key
    )
    requestAnimationFrame(() => scrollToHash(location.hash, 10))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.hash, location.key])

  useEffect(
    () =>
      history.listen(({ action, location: nextLocation }) => {
        if (action === "PUSH") {
          // store the current scroll position into custom history cache
          const historyCache = new Map(
            Object.entries(
              JSON.parse(sessionStorage.getItem("historyCache") || "{}")
            )
          )
          const prevKey = sessionStorage.getItem("key") || "default" // default is the initial key in react router
          const prevScroll = window.scrollY

          // store the current scroll position into custom history cache
          historyCache.set(prevKey, Math.floor(prevScroll))

          // store the custom history cache into session storage
          sessionStorage.setItem(
            "historyCache",
            JSON.stringify(Object.fromEntries(historyCache))
          )

          if (nextLocation.hash) {
            // Hash navigation — let the hash useEffect handle scrolling
            console.log(
              "[ScrollRestoration] PUSH with hash:",
              nextLocation.hash,
              "| skipping scroll-to-top"
            )
          } else {
            // No hash — scroll to the top of the new page
            console.log(
              "[ScrollRestoration] PUSH without hash, scrolling to top"
            )
            window.scrollTo(0, 0)
          }
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return null
}

export default ScrollRestoration
